module.exports = __webpack_public_path__ + "media/solved.fb29553b.wav";